export default "__VITE_ASSET__htQ$nUi1__"